<template>
   <KTCodePreview v-bind:title="'Thông tin phiếu chuyển kho'"
    > <template v-slot:toolbar
      >
      <div
        class="row"
        v-if="stockSlip.id"
      >

        <div>
           <b-row
            class="mb-4 ml-4"
            style="vertical-align: middle; display: inline"
            > <EditToggle
              v-if="stockSlip.id"
              v-model="isEdit"
              id="customSwitch2"
              label="Chỉnh sửa"
            /> </b-row
          >
        </div>

      </div>
       </template
    > <template v-slot:preview
      > <b-row
        class="col-md-12 mb-1 m-0 p-0"
        v-if="stockSlip.relatedStockSlipId"
        >
        <div
          class="alert-header"
          style="width: 100%"
        >
           Tạo phiếu chuyển kho từ phiếu yêu cầu: <span
            class="text-primary orderCode"
            @click="linkToRequest(stockSlip.relatedStockSlipId)"
            style="cursor: pointer"
            >{{ stockSlip.relatedStockSlipCode }}</span
          >
        </div>
         </b-row
      > <StockSlipSkeleton
        :renderComponent="renderComponent"
        v-if="!renderComponent"
      />
      <div v-if="renderComponent">
         <b-row
          class="mb-5 col-12 mb-1 m-0 p-0"
          v-if="stockSlip.code"
          > <label class="font-weight-bold"
            >Mã phiếu kho: <a class="text-primary">{{ stockSlip.code }}</a></label
          > </b-row
        > <b-row class="mb-5 col-6 mb-1 m-0 p-0"
          > <StockSlipTransfer
            :stockSlip="stockSlip"
            :stores="filteredOptions"
            :destinationStores="destinationWarehouses"
            @onSelectedSourceWarehouse="onSelectedSourceWarehouse"
            @onInputChangeSourceWarehouse="onInputChangeSourceWarehouse"
            @onSelectedDestinationWarehouse="onSelectedDestinationWarehouse"
            @onInputChangeDestinationWarehouse="onInputChangeDestinationWarehouse"
            :editable="isEdit"
          /> </b-row
        > <b-row class="mb-5 col-12 mb-1 m-0 p-0"
          > <StockSlipTransferProduct
            :editable="isEdit"
            :productItems="stockSlip.details"
            :storeId="stockSlip.sourceWarehouseId"
            :isSubmitting="isSubmitting"
            :stockSlipType="stockSlip.type"
            ref="stockSlipTransferProduct"
          /> </b-row
        >
      </div>
       </template
    > <template v-slot:foot
      > <b-button
        style="font-weight: 600; width: 70px; margin-right: 10px"
        variant="primary"
        size="sm"
        @click="onSubmit"
        :disabled="!isEdit"
        >Lưu</b-button
      > <b-button
        v-if="!stockSlip.id"
        variant="warning"
        size="sm"
        style="font-weight: 600 !important; width: 120px; margin-right: 10px"
        class="font-weight-bolder"
        @click="onSubmit('save-approve')"
        > Lưu và duyệt </b-button
      > <router-link
        to="/inventory-transfer"
        tag="button"
        > <b-button
          style="margin-left: 10px; font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          >Hủy</b-button
        > </router-link
      > </template
    > </KTCodePreview
  >
</template>

<script>
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import ApiService from '@/core/services/api.service'
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { makeToastFaile, makeToastSuccess, xoa_dau } from '@/utils/common'
  import StockSlipSkeleton from '../../../components/stock-slips/StockSlipSkeleton.vue'
  import StockSlipTransfer from '../../../components/stock-slips/StockSlipTransfer.vue'
  import StockSlipTransferProduct from '../../../components/stock-slips/StockSlipTransferProduct.vue'
  import EditToggle from '@/view/components/common/EditToggle.vue'

  export default {
    mixins: [apiCommonMixin],
    data() {
      return {
        stockSlip: {
          id: null,
          code: '',
          type: 3,
          sourceWarehouseName: '',
          sourceWarehouseId: null,
          destinationWarehouseName: '',
          destinationWarehouseId: null,
          notes: '',
          relatedStockSlipId: null,
          relatedStockSlipCode: '',
          details: [],
        },
        filteredOptions: [],
        sourceWarehouses: [],
        destinationWarehouses: [],
        isSubmitting: false,
        renderComponent: true,
        isEdit: false,
      }
    },
    components: {
      KTCodePreview,
      StockSlipSkeleton,
      StockSlipTransfer,
      StockSlipTransferProduct,
      EditToggle,
    },
    async created() {
      this.filteredOptions = []
      const { stores, currentStoreId, currentStoreName } = await this.fetchStoreByUser()
      this.stores = stores
      this.fetchStore()
      this.filteredOptions = [...this.stores]
      if (currentStoreId && !this.stockSlip.sourceWarehouseId) {
        this.stockSlip.sourceWarehouseId = currentStoreId
        this.stockSlip.sourceWarehouseName = currentStoreName
      }
      this.stockSlip.id = this.$route.query?.id || null
      if (this.stockSlip.id) {
        await this.getStockSlipByID()
      } else {
        this.isEdit = true
        this.stockSlip.relatedStockSlipId = this.$route.query?.requestTransferId || null
        if (this.stockSlip.relatedStockSlipId) {
          await this.getRequestTransferByID()
        }
      }
    },
    methods: {
      createStockSlip: async function (type) {
        const details = this.stockSlip.details.map((element) => {
          const imeis = element.IMEI?.trim() || ''
          return {
            productId: element.productId,
            imeis,
            quantity: element.quantity,
            quantityApprove: element.quantityApprove || 0,
            quantityConfirm: element.quantityConfirm || 0,
          }
        })
        const payload = {
          sourceWarehouseId: this.stockSlip.sourceWarehouseId,
          destinationWarehouseId: this.stockSlip.destinationWarehouseId,
          description: this.stockSlip.notes,
          stockSlipType: this.stockSlip.type,
          relatedStockSlipId: this.stockSlip.relatedStockSlipId,
          details,
        }
        if (!payload.sourceWarehouseId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn kho chuyển!')
        }
        if (!payload.destinationWarehouseId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn kho nhận!')
        }

        if (payload.destinationWarehouseId === payload.sourceWarehouseId) {
          this.isSubmitting = false
          return makeToastFaile('Kho nhận và kho chuyển không dược phép trùng nhau!')
        }

        if (!payload.details || payload.details.length === 0) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn sản phẩm!')
        }

        try {
          const url =
            type === 'save-approve' ? 'v1/transfer-stock-slips/approved' : 'v1/transfer-stock-slips'
          const res = await ApiService.post(url, payload).catch((error) => {
            this.isSubmitting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
          makeToastSuccess(res.data.message)
          this.$router.push({
            name: 'list-inventory-transfer',
          })
        } catch ({ response }) {
          makeToastFaile(response.$error)
        } finally {
          this.isSubmitting = false
        }
      },
      updateStockSlip: async function () {
        const details = this.stockSlip.details.map((element) => {
          const imeis = element.IMEI?.trim() || ''
          return {
            id: element.id,
            productId: element.productId,
            imeis,
            quantity: element.quantity,
            quantityApprove: element.quantityApprove || 0,
            quantityConfirm: element.quantityConfirm || 0,
          }
        })
        const payload = {
          id: this.stockSlip.id,
          sourceWarehouseId: this.stockSlip.sourceWarehouseId,
          destinationWarehouseId: this.stockSlip.destinationWarehouseId,
          description: this.stockSlip.notes,
          details,
        }
        if (!payload.sourceWarehouseId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn kho chuyển!')
        }
        if (!payload.destinationWarehouseId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn kho nhận!')
        }

        if (payload.destinationWarehouseId === payload.sourceWarehouseId) {
          this.isSubmitting = false
          return makeToastFaile('Kho nhận và kho chuyển không dược phép trùng nhau!')
        }
        if (!payload.details || payload.details.length === 0) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn sản phẩm!')
        }
        try {
          const res = await ApiService.put('v1/transfer-stock-slips', payload).catch((error) => {
            this.isSubmitting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
          makeToastSuccess(res.data.message)
          this.$router.push({
            name: 'list-inventory-transfer',
          })
        } catch ({ response }) {
          makeToastFaile(response.$error)
        } finally {
          this.isSubmitting = false
        }
      },
      onSubmit(type) {
        if (this.isSubmitting) return
        this.isSubmitting = true
        const isValid = this.$refs.stockSlipTransferProduct.validateImeiProducts()
        if (!isValid) {
          this.isSubmitting = false
          return
        }
        if (!this.stockSlip.id) {
          this.createStockSlip(type)
          return
        }
        this.updateStockSlip()
      },
      onSelectedSourceWarehouse(option) {
        this.stockSlip.sourceWarehouseName = option.item.name
        this.stockSlip.sourceWarehouseId = option.item.id
      },
      onInputChangeSourceWarehouse(text) {
        this.stockSlip.sourceWarehouseName = text
        const filteredData = this.stores
          .filter((item) => {
            return (
              xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1 ||
              item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
            )
          })
          .slice(0, 10)
        this.filteredOptions = [...filteredData]
      },
      onSelectedDestinationWarehouse(option) {
        this.stockSlip.destinationWarehouseName = option.item.name
        this.stockSlip.destinationWarehouseId = option.item.id
      },
      onInputChangeDestinationWarehouse(text) {
        this.stockSlip.destinationWarehouseName = text
        const filteredData = this.stores
          .filter((item) => {
            return (
              xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1 ||
              item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
            )
          })
          .slice(0, 10)
        this.filteredOptions = [...filteredData]
      },
      getStockSlipByID: async function () {
        this.renderComponent = false
        ApiService.get(`v1/transfer-stock-slips/${this.stockSlip.id}`).then((data) => {
          const stockSlipData = data.data.data
          this.stockSlip.code = stockSlipData.code
          this.stockSlip.type = stockSlipData.type
          this.stockSlip.sourceWarehouseId = stockSlipData.sourceWarehouseId
          this.stockSlip.sourceWarehouseName = stockSlipData.sourceWarehouseName
          this.stockSlip.destinationWarehouseId = stockSlipData.destinationWarehouseId
          this.stockSlip.destinationWarehouseName = stockSlipData.destinationWarehouseName
          this.stockSlip.notes = stockSlipData.description
          this.stockSlip.relatedStockSlipId = stockSlipData.relatedStockSlipId
          this.stockSlip.relatedStockSlipCode = stockSlipData.relatedStockSlipCode
          this.stockSlip.details = stockSlipData.details.map((detail, index) => {
            return {
              ...detail,
              stt: index + 1,
              productPriceMask: detail.unitPrice,
              IMEI: detail.productImei || '',
            }
          })
          this.renderComponent = true
        })
      },
      getRequestTransferByID: async function () {
        ApiService.get(`v1/transfer-stock-slips/request/${this.stockSlip.relatedStockSlipId}`).then(
          (data) => {
            const stockSlipData = data.data.data
            this.stockSlip.relatedStockSlipCode = stockSlipData.code
            this.stockSlip.sourceWarehouseId = stockSlipData.sourceWarehouseId
            this.stockSlip.sourceWarehouseName = stockSlipData.sourceWarehouseName
            this.stockSlip.destinationWarehouseId = stockSlipData.destinationWarehouseId
            this.stockSlip.destinationWarehouseName = stockSlipData.destinationWarehouseName
            this.stockSlip.notes = stockSlipData.description
            this.stockSlip.details = stockSlipData.details.map((detail, index) => {
              return {
                ...detail,
                stt: index + 1,
                productPriceMask: detail.unitPrice,
                IMEI: detail.productImei || '',
                requestQuantity: detail.quantity,
              }
            })
          },
        )
      },
      linkToRequest: function (relatedStockSlipId) {
        const { href } = this.$router.resolve({
          name: 'edit-request-transfer',
          query: { id: relatedStockSlipId },
        })
        window.open(href, '_blank')
      },
      fetchStore: async function () {
        this.filteredOptions = []
        ApiService.get('v1/stores/all').then((response) => {
          this.destinationWarehouses = response.data.data
          this.filteredDStockOptions = [...this.destinationWarehouses]
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .alert-header {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.orderCode:hover {
  text-decoration: underline;
}
</style>

